import "./index.less";
import "react-dates/initialize";
import * as React from "react";
import { AtButton } from "@atman/design-system";
import { DateRangePicker, DateRangePickerShape, isSameDay } from "react-dates";
import { Moment } from "moment";
import moment from "moment";

export interface IDatePreset {
    start: Moment;
    end: Moment;
    labelOverride?: string;
}

export interface ICustomDateRangePickerProps extends DateRangePickerShape {
    datePresets?: IDatePreset[];
}

export const CustomDateRangePicker: React.FC<ICustomDateRangePickerProps> = (props: ICustomDateRangePickerProps) => {
    const {
        datePresets,
        startDate,
        endDate,
        onDatesChange,
        startDateId,
        endDateId,
        focusedInput,
        onFocusChange,
        ...otherProps
    } = props;

    const renderDatePresets = () => {
        if (!datePresets) {
            return "";
        }

        return (
            <div className={"presets-container"}>
                {datePresets.map(({ start, end, labelOverride }, i) => {
                    const isSelected =
                        !!startDate &&
                        isSameDay(start, startDate) &&
                        ((endDate === null && end === null) || (!!end && !!endDate && isSameDay(end, endDate)));

                    return (
                        <AtButton
                            active={isSelected}
                            size={"md"}
                            color={"secondary"}
                            key={i}
                            onClick={() => onDatesChange({ startDate: start, endDate: end })}
                        >
                            {labelOverride ?? moment.duration(start.diff(end)).humanize()}
                        </AtButton>
                    );
                })}
            </div>
        );
    };

    return (
        <div className="CustomDateRangePicker">
            <DateRangePicker
                startDate={startDate}
                startDateId={startDateId}
                endDate={endDate}
                endDateId={endDateId}
                renderCalendarInfo={renderDatePresets}
                focusedInput={focusedInput}
                onFocusChange={onFocusChange}
                onDatesChange={onDatesChange}
                hideKeyboardShortcutsPanel
                startDatePlaceholderText={"global.startDate".localize()}
                endDatePlaceholderText={"global.endDate".localize()}
                {...otherProps}
            />
        </div>
    );
};
